import React from 'react'

import { Container, Reposition, Circle } from './circle-static.css'

const CircleStatic = ({ x, y }) => (
  <Container>
    <Reposition />
    <Circle x={x} y={y} />
  </Container>
)

export default CircleStatic
